// extracted by mini-css-extract-plugin
export default {"root":"IconSecurity_root__pbaQ7"};